export const ScrollToPosition = (pos, scroll) => {
  if (pos) {
    const top = parseInt(document.querySelector('html').style.top) * -1;
    document.body.classList.remove('popup_active');
    document.querySelector('html').style.top = '0px';
    window.scrollTo(0, top)
  } else {
    document.body.classList.add('popup_active');
    document.querySelector('html').style.top = '-'+ scroll +'px';
  }
};